import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

type LogbookOrdersFilterProps = {
	showOrders: boolean;
	onChange: (show: boolean) => void;
};

export const LogbookOrdersFilter = ({ showOrders, onChange }: LogbookOrdersFilterProps) => {
	return (
		<FormControl size="small" sx={{ minWidth: 100, maxWidth: 400, flex: 1 }}>
			<InputLabel>Compras</InputLabel>
			<Select
				value={showOrders ? "show" : "hide"}
				label="Compras"
				onChange={(e) => onChange(e.target.value === "show")}
			>
				<MenuItem value="show">Mostrar compras</MenuItem>
				<MenuItem value="hide">Não mostrar compras</MenuItem>
			</Select>
		</FormControl>
	);
};
